module.exports = __webpack_public_path__ + "img/man-icon.de8065bb.svg";